import { HoldingFeeCycleStatus, HoldingFeeService, PerformerContractService } from '@talon/web/lib/api';
import { BaseStore } from './baseStore';

export class HoldingFeeStore extends BaseStore {
  getSchedule = async (contractId: string) => {
    try {
      return await PerformerContractService.getHoldingFeeSchedule(contractId);
    } catch (e) {
      this.handleError(e);
    }
  };

  updateCycle = async (contractId: string, cycleNumber: number, status: HoldingFeeCycleStatus, notes?: string) => {
    try {
      const { cycle } = await PerformerContractService.updateHoldingFeeCycle(contractId, cycleNumber, {
        status,
        notes,
      });
      return cycle;
    } catch (e) {
      this.handleError(e);
    }
  };

  getProjectDueSoon = async (projectId: string, withinDays?: number) => {
    try {
      const { items } = await HoldingFeeService.listProjectHoldingFeesDue(projectId, withinDays);
      return items;
    } catch (e) {
      this.handleError(e);
    }
  };
}
